import React from "react";
import { getValue } from "@utils/lodash";

function MoreSupportSvgComponent(props: any) {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        width={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        viewBox="0 0 24 24"
      >
        <defs>
          <clipPath id="clip-path8">
            <rect
              id="Rectangle_18189"
              data-name="Rectangle 18189"
              width="24"
              height="24"
              transform="translate(-14599 -8195)"
              fill="#fff"
            />
          </clipPath>
        </defs>
        <g
          id="Mask_Group_297"
          data-name="Mask Group 297"
          transform="translate(14599 8195)"
          clipPath="url(#clip-path8)"
        >
          <path
            id="support_FILL0_wght300_GRAD0_opsz24"
            d="M13.16-7.158a9.741,9.741,0,0,1-3.9-.787,10.1,10.1,0,0,1-3.176-2.137,10.1,10.1,0,0,1-2.138-3.174,9.732,9.732,0,0,1-.788-3.9,9.741,9.741,0,0,1,.787-3.9,10.1,10.1,0,0,1,2.137-3.176A10.1,10.1,0,0,1,9.257-26.37a9.732,9.732,0,0,1,3.9-.788,9.741,9.741,0,0,1,3.9.787,10.1,10.1,0,0,1,3.176,2.137,10.1,10.1,0,0,1,2.138,3.174,9.732,9.732,0,0,1,.788,3.9,9.741,9.741,0,0,1-.787,3.9,10.1,10.1,0,0,1-2.137,3.176,10.1,10.1,0,0,1-3.174,2.138,9.732,9.732,0,0,1-3.9.788ZM10.105-9.316l1.547-3.522a4.4,4.4,0,0,1-1.7-1.079,4.949,4.949,0,0,1-1.092-1.715L5.3-14.158a8,8,0,0,0,1.879,2.947A8.213,8.213,0,0,0,10.105-9.316ZM8.858-18.684a4.552,4.552,0,0,1,1.078-1.7,4.608,4.608,0,0,1,1.7-1.072L10.158-25.02a8.279,8.279,0,0,0-2.958,1.9,8.279,8.279,0,0,0-1.9,2.958Zm4.3,4.522a2.9,2.9,0,0,0,2.123-.873,2.883,2.883,0,0,0,.876-2.12,2.9,2.9,0,0,0-.873-2.123,2.883,2.883,0,0,0-2.12-.876,2.9,2.9,0,0,0-2.123.873,2.883,2.883,0,0,0-.876,2.12,2.9,2.9,0,0,0,.873,2.123,2.883,2.883,0,0,0,2.12.876Zm3.055,4.846A8.189,8.189,0,0,0,19.118-11.2,8.189,8.189,0,0,0,21-14.105l-3.522-1.547a4.312,4.312,0,0,1-1.059,1.69,5.064,5.064,0,0,1-1.682,1.1Zm1.247-9.421L21-20.211a8.189,8.189,0,0,0-1.882-2.908A8.189,8.189,0,0,0,16.211-25l-1.474,3.575a4.7,4.7,0,0,1,1.636,1.061,4.958,4.958,0,0,1,1.085,1.628Z"
            transform="translate(-14600.158 -8165.842)"
            fill={
              getValue(props, `color`, "")
                ? getValue(props, `color`, "")
                : "#5f6368"
            }
          />
        </g>
      </svg>
    </div>
  );
}

export default MoreSupportSvgComponent;
